import { inject, Injectable } from '@angular/core';

import { App } from '@capacitor/app';
import { Device } from '@capacitor/device';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { combineLatest, from, of, switchMap } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import * as fromDeviceActions from '../actions/device.actions';

@Injectable()
export class DeviceEffects {
  private actions$ = inject(Actions);

  loadDeviceInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromDeviceActions.loadDeviceInfo),
      mergeMap(() =>
        combineLatest([from(Device.getInfo()), from(Device.getId())]).pipe(
          map(([deviceInfo, deviceId]) =>
            fromDeviceActions.loadDeviceInfoSuccess({
              payload: {
                info: deviceInfo,
                uuid: deviceId.identifier
              }
            })
          ),
          catchError((error: Error) => of(fromDeviceActions.loadDeviceInfoFailure({ payload: { error } })))
        )
      )
    )
  );

  loadAppInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromDeviceActions.loadDeviceInfo),
      switchMap(() =>
        from(App.getInfo()).pipe(
          map((appInfo) => fromDeviceActions.loadAppInfoSuccess({ payload: { appInfo } })),
          catchError((error: Error) => of(fromDeviceActions.loadAppInfoFailure({ payload: { error } })))
        )
      )
    )
  );
}
